const NullComponent = () => null;

export default NullComponent;